// Generated by CoffeeScript 2.3.2

import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import React from 'react';
;
var PlayerChoices, PlayerChooser,
  indexOf = [].indexOf;

PlayerChoices = function(props) {
  var excluded, id, onChange, players, value;
  ({value, players, excluded, onChange} = props);
  return <RadioGroup row name="players" value={value} onChange={onChange}>
    {(function() {
    var i, len, results;
    results = [];
    for (i = 0, len = players.length; i < len; i++) {
      id = players[i];
      results.push(<FormControlLabel key={id} value={id} control={<Radio />} label={id} disabled={(excluded != null) && indexOf.call(excluded, id) >= 0} />);
    }
    return results;
  })()}
  </RadioGroup>;
};

PlayerChooser = function(props) {
  var excluded, onChange, players, value;
  ({value, players, excluded, onChange} = props);
  return <FormControl component="fieldset">
    <PlayerChoices value={value} players={players} excluded={excluded} onChange={function(event) {
      return onChange(event.target.value);
    }} />
  </FormControl>;
};

export default PlayerChooser;
